/**
 * chapter-shut.ts — each reason a chapter is shut (ChapterShut, gating.ts) in
 * the words the student reads it by: under a shut activity, the first reason;
 * on the campaign's chapter trail, each that holds. The two mapped the reasons
 * to their keys apart, and the trail had no words for a campaign not yet begun.
 */

import type { TFunction } from 'i18next';
import type { ChapterShut } from '../../../api/student/campaigns/gating';
import type { StudentCampaignChapter } from '../../../api/student/campaigns/types';
import { formatDate } from '../../../utils/format-date';

/** Each reason's key, written whole. */
const SHUT_WORDS: Record<ChapterShut, string> = {
  campaignNotStarted: 'student.campaigns.notYetActive',
  notScheduled: 'student.campaigns.chapterNotScheduled',
  beforeStart: 'student.campaigns.chapterLocked',
  prevChapter: 'student.campaigns.chapterPrevRequired',
};

/** A reason a chapter is shut, in words: the chapter's start date among them where the reason is the date. */
export function shutWords(t: TFunction, why: ChapterShut, chapter: StudentCampaignChapter): string {
  return t(SHUT_WORDS[why], { date: formatDate(chapter.startDateUtc) });
}
